import * as angular from "angular";
import {IController} from "angular";
import * as PhoneFormat from "phoneformat.js";
import {SitesRequestsService} from "../../../sites/services/sites-requests.service";


export class ValidatedPhoneInputCtrl implements IController {
  phone: string;
  checkExist: any;
  ngRequired: boolean;
  form: any;

  private siteId: string;
  private country: string;
  private initMobilePhone: string;

  constructor(private splitService, private sitesRequestsService: SitesRequestsService, private IamService, private $filter, private $log) {
    this.country = splitService.getCountryCode();
    this.siteId = splitService.getSiteId();
    this.initMobilePhone = PhoneFormat.formatLocal(this.country, this.phone);
  }

  phoneChanged() {
    this.sitesRequestsService.validatePhoneNumber(this.siteId, this.phone, this.country)
      .then((res) => {
        if (res.isValid) {

          const validMobilePhone = PhoneFormat.formatLocal(this.country, this.phone);
          this.form.phone.$setValidity('valid', true);

          if (this.checkExist) {
            //Same phone, skip the validation
            if (validMobilePhone === this.initMobilePhone) {
              this.form.phone.$setValidity('exists', true);
            } else {

              const formatedE164MobilePhone = PhoneFormat.formatE164(this.country, validMobilePhone);

              this.IamService.validateUserPhone(formatedE164MobilePhone)
                .then((valid) => {

                  if (valid && formatedE164MobilePhone.length > 8) {
                    this.phone = this.$filter('bringozPhone')(formatedE164MobilePhone);
                  } else {
                    this.form.phone.$setValidity('valid', false);
                  }
                  this.form.phone.$setValidity('exists', valid);

                }, () => {
                  this.$log.debug('Fail to validate user phone');
                });
            }
          }

        } else {

          if (!this.phone && !this.ngRequired) {
            this.form.phone.$setValidity('valid', true);
          } else {
            this.form.phone.$setValidity('valid', false);
            this.form.phone.$setValidity('exists', true);
          }

        }
      })
      .catch((error) => {
        this.form.phone.$setValidity('valid', false);
      })
  }
}

angular
  .module('bringoz.admin.commons')
  .component('validatedPhoneInput', {
    require: {
      form: '^form'
    },
    bindings: {
      phone: '<',
      checkExist: '<?',
      ngRequired: '<'
    },
    template: require('./validated-phone-input.html').default,
    controller: ValidatedPhoneInputCtrl
  });

